module.exports = __webpack_public_path__ + "media/images/icons/country_flags/re-9d72b568db01dfb982e8dee01a86d235.svg";